import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'pl-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  @HostBinding('class') public classes: string = 'w-16 h-16';
}
